import { useQuery } from '@tanstack/react-query';

import { diseaseCodeApi } from '../api/disease-code.adapter';
import { diseaseCodeQueryKeys } from './use-disease-groups';

// Fetches codes for `groupId`. Pass `null` while no group is selected — the
// query stays disabled so we don't hit the adapter with a sentinel value.
// v9: groupId is number (BIGINT UNSIGNED).
export function useDiseaseCodesQuery(groupId: number | null) {
  return useQuery({
    queryKey: diseaseCodeQueryKeys.codes(groupId ?? -1),
    queryFn: () => diseaseCodeApi.listCodes(groupId as number),
    enabled: groupId !== null,
  });
}
